module.exports = __webpack_public_path__ + "img/filter.5227ef40.svg";